import React from "react";
import { Card, CardBody, Col } from "reactstrap";

const ObservedInd = () => {


  return (
    <Col>
      <Card>
        <CardBody>
          {/* Heading */}
          <h4 className="card-title text-center mb-3">Multiples Observed in Industry</h4>

        

          {/* Table */}
          <div className="mt-4">
            <table className="table mb-0">
              <tbody>
                <tr>
                  <td>
                    <span className="badge bg-primary">Low</span>
                  </td>
                  <td>1.7</td>
                </tr>
                <tr>
                  <td>
                    <span className="badge bg-success">Medium</span>
                  </td>
                  <td>2.04</td>
                </tr>
                <tr>
                  <td>
                    <span className="badge bg-warning">High</span>
                  </td>
                  <td>4.2</td>
                </tr>
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ObservedInd;
